import React from 'react';
import CampoComboPais from '../../UI/campos/CampoComboPais.js';
import * as Campos from '../../constantes/Campos.js';
import styles from '../EditarItemLista.module.css';

const CamposTorneoSede = (props) => {
  const item = props.item;
  const editar = props.editar;
  const actualizar = props.actualizar;

  const onCampoChange = (campo, valor) => {
    props.onCampoChange(campo, valor);
  };

  return (
    <React.Fragment>
      <tr>
        <td className={`${styles.titulo}`}>País Sede</td>
        <td className={`${styles.valor}`}>
          <CampoComboPais
            editar={editar}
            nombre={Campos.TorneoSede.PAIS}
            valor={item?.paisSede}
            incluirNulo={false}
            actualizar={actualizar}
            onChange={onCampoChange}
          />
        </td>
      </tr>
    </React.Fragment>
  );
};

export default CamposTorneoSede;
